import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const Log: WorkflowActivityDefinition = {
  group: 'internal',
  name: 'log',
  type: 'activity',
  isFlowControl: true,
  schema: {
    type: 'object',
  },
  defaults: {},
  inputs: [
    {
      type: 'flowControl',
      name: 'inFlow',
    },
    {
      type: 'any',
      name: 'log',
    },
  ],
  outputs: [
    {
      type: 'flowControl',
      name: 'outFlow',
    },
  ],
  // action: async (inputs, context) => {
  //   console.log(inputs, context);
  //   // return inputs;
  // },
};

registerActivity(Log);
